import React, { memo } from "react";

export const ProductSdrPopover = memo(function ProductSdrPopover({
  product,
  onChange,
  onClear,
  onApply,
}) {
  const sdrChargesId = `sdrCharges-${product?.sid}`;
  const requestId = `specialDesignRequest-${product?.sid}`;

  return (
    <span className="popover__wrapper product-sdr-popover">
      <div className="popover__content product-sdr-panel" role="dialog" aria-label="SDR charges">
        <div className="product-sdr-panel__header">
          <span>SDR Charges</span>
          <small>Optional product-level request</small>
        </div>

        <div className="product-sdr-panel__field">
          <label htmlFor={sdrChargesId}>Charges</label>
          <input
            id={sdrChargesId}
            className="form-control"
            name="sdrCharges"
            type="number"
            value={product?.sdrCharges || ""}
            placeholder="Enter charges"
            onChange={(event) => onChange(event, product)}
            onWheel={(event) => event.currentTarget.blur()}
          />
        </div>

        <div className="product-sdr-panel__field">
          <label htmlFor={requestId}>Special Design Request</label>
          <textarea
            id={requestId}
            className="form-control"
            rows="4"
            name="specialDesignRequest"
            placeholder="Enter request details"
            value={product?.specialDesignRequest || ""}
            onChange={(event) => onChange(event, product)}
          />
        </div>

        <div className="product-sdr-panel__actions">
          <button type="button" className="btn cancel-btn" onClick={(event) => onClear(event, product)}>
            Clear
          </button>
          <button type="button" className="btn save-btn" onClick={onApply}>
            Apply
          </button>
        </div>
      </div>
    </span>
  );
});
